'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X, Sparkles, Map, ShieldCheck, LogIn } from 'lucide-react';

const navLinks = [
  { href: '/', label: 'Claim Block', icon: Sparkles },
  { href: '/block-map', label: 'Block Map', icon: Map },
  { href: '/admin-panel', label: 'Admin', icon: ShieldCheck },
  { href: '/sign-up-login-screen', label: 'Sign In', icon: LogIn },
];

export default function PublicTopbar() {
  const pathname = usePathname();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-16 flex items-center px-6 lg:px-10"
      style={{ background: 'rgba(10,10,20,0.85)', backdropFilter: 'blur(16px)', borderBottom: '1px solid rgba(201,168,76,0.15)' }}>
      <div className="flex items-center gap-3 flex-1">
        <Link href="/" className="flex items-center gap-2">
          <AppLogo size={36} />
          <span className="font-display text-lg font-semibold gold-gradient-text tracking-wider hidden sm:block">
            MiracleChain
          </span>
        </Link>
        <div className="hidden sm:flex items-center gap-1.5 ml-3 px-3 py-1 rounded-full border border-emerald-500/30 bg-emerald-500/10">
          <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
          <span className="text-xs font-medium text-emerald-400">6,000,000 Blocks Remaining</span>
        </div>
      </div>
      {/* Desktop nav */}
      <nav className="hidden md:flex items-center gap-1">
        {navLinks?.map((link) => {
          const isActive = pathname === link?.href;
          return (
            <Link
              key={`nav-${link?.href}`}
              href={link?.href}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                isActive
                  ? 'text-primary bg-primary/10 glow-gold-sm' :'text-muted-foreground hover:text-foreground hover:bg-muted'
              }`}
            >
              <link.icon size={15} />
              {link?.label}
            </Link>
          );
        })}
      </nav>
      {/* Mobile hamburger */}
      <button
        className="md:hidden p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-all"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        {menuOpen ? <X size={20} /> : <Menu size={20} />}
      </button>
      {/* Mobile drawer */}
      {menuOpen && (
        <div className="absolute top-16 left-0 right-0 cosmic-card border-t border-border md:hidden z-50">
          <nav className="flex flex-col p-4 gap-1">
            {navLinks?.map((link) => {
              const isActive = pathname === link?.href;
              return (
                <Link
                  key={`mobile-nav-${link?.href}`}
                  href={link?.href}
                  onClick={() => setMenuOpen(false)}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? 'text-primary bg-primary/10' :'text-muted-foreground hover:text-foreground hover:bg-muted'
                  }`}
                >
                  <link.icon size={16} />
                  {link?.label}
                </Link>
              );
            })}
          </nav>
        </div>
      )}
    </header>
  );
}